import {Component, h, Prop,} from '@stencil/core';
import {StepsError, Translations} from '../../../redux/types';
import {StepErrorType} from '../../../types/types';
import {trans} from "../../../utils/trans";

@Component({
    tag: 'rentware-checkout-error',
    styleUrl: 'style.sass',
    shadow: true,
})
export class RentwareCheckoutError {
    @Prop() currentStep;
    @Prop() errors: StepsError[];
    @Prop() handleGoToFirstErrorClick;
    @Prop() translations: Translations;
    @Prop() locale: string;

    get currentStepErrors(): StepsError[] {
        return this.errors?.filter(error => error.stepId === this.currentStep.id);
    }

    get errorMessages() {
        return {
            [StepErrorType.ShippingNoOptionSelected]: trans('checkout.validationShippingMethodRequired', this.locale, this.translations),
            [StepErrorType.ShippingDistanceProblem]: trans('checkout.validationShippingDistanceProblem', this.locale, this.translations),
            [StepErrorType.BillingNotAllFieldsValid]: trans('checkout.validationRequiredFields', this.locale, this.translations),
            [StepErrorType.PaymentNoOptionSelected]: trans('payment.notesNoMethod', this.locale, this.translations),
            [StepErrorType.SecondaryPaymentNoOptionSelected]: trans('payment.notesNoMethod', this.locale, this.translations),
            [StepErrorType.PaymentNotAcceptedTerms]: trans('checkout.validationAcceptTerms', this.locale, this.translations),
            [StepErrorType.PaymentProblemWithMethod]: trans('payment.errorGeneric', this.locale, this.translations),
            [StepErrorType.PaymentProblemWithPasscode]: trans('checkout.validationEnterPasscode', this.locale, this.translations),
            [StepErrorType.PaymentFailed]: trans('payment.errorGeneric', this.locale, this.translations),
            [StepErrorType.StepInvalid]: trans('payment.errorGeneric', this.locale, this.translations),
            [StepErrorType.FormNotAllFieldsValid]: trans('checkout.validationRequiredFields', this.locale, this.translations),
        }
    }

    get genericError(): string {
        return "Error"; // todo: translate
    }

    mappedError = (error) => {
        const clickable =
            error.type === StepErrorType.ShippingNoOptionSelected ||
            error.type === StepErrorType.ShippingDistanceProblem ||
            error.type === StepErrorType.BillingNotAllFieldsValid ||
            error.type === StepErrorType.FormNotAllFieldsValid ||
            error.type === StepErrorType.PaymentNoOptionSelected ||
            error.type === StepErrorType.PaymentNotAcceptedTerms ||
            error.type === StepErrorType.PaymentProblemWithMethod;

        return (
            <div
                class={{ErrorItem: true, Clickable: clickable}}
                onClick={() => clickable && this.handleGoToFirstErrorClick(error.type)}
            >
                <div class="ErrorLeft">
                    {(!!this.errorMessages[error.type] && this.errorMessages[error.type]) ||
                        (!error.message && this.genericError)
                    }

                    {!!error.message &&
                        <span>
                            {error.message}
                        </span>
                    }
                </div>

                {clickable &&
                    <div class="ErrorRight">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M12 3L12 18M12 18L17 12.9701M12 18L7 12.9701" stroke="white" stroke-linecap="round"
                                  stroke-linejoin="round"/>
                            <path d="M7 20L17 20" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                    </div>
                }
            </div>
        )
    }

    render() {
        return (
            <div
                class="Error"
            >
                {this.currentStepErrors.map(this.mappedError)}
            </div>
        )
    }
}
